import React, { useEffect, useState } from "react";
import "../UserSetting/toggle-css.css";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../../components/loading";
import {
  LoadSettings,
} from "../../../../general_redux/general settings/actions";
import countryList from "react-select-country-list";
import {
  updateUserInfo,
} from "../../../../general_redux/user/actions";
import styles2 from "../Guest/guest.module.css";
import Calendar from "./components/Calendar";
import Invoice from "./components/Invoice";
import Notification from "./components/Notification";
import Payments from "./components/Payments";
import General from "./components/General";

function Settings() {
  useEffect(() => {
    dispatch(LoadSettings());
  }, []);
  
  const {
    setting,
    actionForSettings,
    actionForSettingsEdit,
  } = useSelector(({ generalSetting }) => generalSetting && generalSetting);
  const actionForStripeConnect = useSelector(
    ({ user }) => user && user.actionForStripeConnect
  );
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState("General");

  const tabs = ["General", "Calendar", "Invoice", "Notification", "Payments"];

  useEffect(() => {
    const response = {
      customer: { ...setting, currency: setting.currency.value },
      colors_setting: setting?.colors,
    };
    dispatch(updateUserInfo(response));
  }, [actionForSettingsEdit]);

  const handleTab = (tab) => {
    setCurrentTab(tab);
  };

  return (
    <div>
      <Loading
        loadingStatus={
          actionForSettings.loading ||
          actionForSettingsEdit.loading ||
          actionForStripeConnect.loading
        }
      />
      <div style={{ margin: "0em 1em" }}>
        <div className={styles2.upperRow}>
          {tabs.length !== 0 &&
            tabs.map((tab, index) => (
              <a
                className={
                  currentTab === tab
                    ? `${styles2.tabBox} ${styles2.active}`
                    : `${styles2.tabBox}`
                }
                key={index}
                onClick={() => handleTab(tab)}
              >
                {tab}
              </a>
            ))}
        </div>
        <div>
          {currentTab === "General" && <General />}
          {currentTab === "Calendar" && <Calendar />}
          {currentTab === "Invoice" && <Invoice />}
          {currentTab === "Notification" && <Notification />}
          {currentTab === "Payments" && <Payments />}
        </div>
      </div>
    </div>
  );
}

export default Settings;
